import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ coach, size = "sm" }) {
  if (!coach?.verified) return null;
  const cls = size === "lg" ? "text-sm px-3 py-1" : "text-[11px] px-2 py-0.5";
  return (
    <span data-testid={`verified-badge-${coach.id}`} title={`${coach.paid_sessions} séances réglées via TymCoach`}
      className={`inline-flex items-center gap-1 rounded-full font-semibold bg-sky-500/10 text-sky-700 border border-sky-500/30 ${cls}`}>
      <BadgeCheck className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} /> Coach vérifié
    </span>
  );
}
